import { Router } from "react-router-dom";
import "./App.css";
import Routes from "./Routes";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { CssBaseline, ThemeProvider } from "@mui/material";
import { history } from './helpers/history';
import { theme } from './commons/theme';
import { useEffect, useState } from "react";
import { TranslationProvider } from "./commons/useTranslasion";
import ExternalScripts from "./components/ExternalScripts";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 100);
  }, []);

  return (
    <TranslationProvider>
      {!loading && (
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <ExternalScripts />
          <Router history={history}>
            <Routes />
          </Router>
          <ToastContainer />
        </ThemeProvider>
      )}
    </TranslationProvider>
  );
}

export default App;
